import { Component, OnInit } from '@angular/core';
import { Student } from '../../models/student.model';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService } from '../../services/student.service';
import { forkJoin } from 'rxjs';
import { ExtraInfoService } from '../../services/extra-info.service';
import { GenderService } from '../../../genders/services/gender.service';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { ExtraInfo } from '../../models/extra-info.model';
import { Gender } from '../../../genders/models/gender.model';

@Component({
    selector: 'app-student-edition',
    templateUrl: './student-edition.component.html',
    styleUrls: ['./student-edition.component.scss']
})
export class StudentEditionComponent implements OnInit {

    public headerTitle     : string = 'Participantes';
    public headerButtonText: string = 'Volver';
    public headerButtonIcon: string = 'arrow-left';
    public headerButtonUrl : string = '/participantes';

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();
    public loadingErrorMessage: string  = 'Se ha producido un error al cargar la página.';

    public studentId : number;

    public student   : Student;
    public genders   : Gender[];
    public extraInfos: ExtraInfo[];

    public showError   : boolean = false;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private studentService: StudentService,
        private genderService: GenderService,
        private extraInfoService: ExtraInfoService) { }

    ngOnInit(): void {

        let route = this.router.url;
        if (route.includes('edicion'))
        {
            this.studentId = this.activatedRoute.snapshot.params["id"];
        }
        this.initData();

    }

    private initData() {

        let forkData: any = {
            gendersRequest   : this.genderService.get(),
            extraInfosRequest: this.extraInfoService.get()
        }

        if (this.studentId) {
            forkData.studentRequest = this.studentService.getById(this.studentId)
        }

        forkJoin(forkData).subscribe({

            next: (requests: any) => {

                this.student    = this.studentId ? requests.studentRequest : null;
                this.genders    = requests.gendersRequest;
                this.extraInfos = requests.extraInfosRequest;

            },

            error: (error: any) => {

                this.loadingMessage.showDangerAlert(this.loadingErrorMessage);

            }

        }).add(() => {
            this.isLoadingData = false;
        });

    }

}
